import { DialogWrapper } from '@cellebrite/saas-ui-common';
import { Box, Typography } from '@mui/material';
import React from 'react';
import { i18n } from 'src/common/i18n/i18n';

interface ReactionsDialogProps {
    close: () => any;
    data: any;
}

const ReactionsDialog = ({ close, data }: ReactionsDialogProps) => {
    return (
        <DialogWrapper
            onClose={close}
            styles={{ 'width': '762px', 'height': '762px', '& .MuiDialogContent-root': { paddingTop: 0 } }}
            title={
                <Box>
                    <Typography variant="s18w700" className="color-bd" sx={{ mb: 1 }}>
                        {i18n.translate('Reactions')}
                    </Typography>
                    <Typography>{data.reactionCounts}</Typography>
                </Box>
            }
            content={data.content}
        />
    );
};

export default ReactionsDialog;
